module.exports = __webpack_public_path__ + "img/symbol_6.1ec5a12b.png";